import { Directive, ElementRef, Input, HostListener } from "@angular/core";

@Directive({
  selector: "[appNumbersOnly]"
})
export class NumbersOnlyDirective {
  constructor(private elem: ElementRef) {}

  @HostListener("keyup")
  onKeyPress() {
    this.elem.nativeElement.value = this.formatNumbersOnly(this.elem.nativeElement.value);
  }

  private formatNumbersOnly(isNumber: string): string {
    isNumber = isNumber.replace(/[^0-9]/g, "");
    return isNumber;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/numbers-only.directive.ts